export default __webpack_public_path__ + "static/media/kemhan-cover.3a4e56e2.jpeg";